<template>
<div class="site-content">
  <swiper class="site-content-banner" :options="swiperOption">
    <swiper-slide>
      <img src="./../../assets/index_banner6.jpg"/>
    </swiper-slide>
    <swiper-slide>
      <img src="./../../assets/index_banner7.jpg"/>
    </swiper-slide>
    <swiper-slide>
      <img src="./../../assets/index_banner4.png"/>
    </swiper-slide>
<!--    <swiper-slide>-->
<!--      <img src="./../../assets/index_banner5.png"/>-->
<!--    </swiper-slide>-->
<!--    <div class="swiper-pagination" slot="pagination"></div>-->
  </swiper>
  <div class="site-content-page width-per-100">
    <!--牛油果行情-->
    <div class="content-row"><chartTabList02-01 title="牛油果行情" label="AVOCADO MARKET" col="2"/></div>
    <!--牛油果直供-->
    <div class="content-row"><infoTabList-01 title="牛油果直供" label="ONLINE EXHIBITION" col="3" count="6"/></div>
    <!--供应链服务-->
    <div class="content-row  content-row-c1" style="margin-top: 20px;"><imgLink-01 title="供应链服务" label="SUPPLY SERVICE" :showMore="false" count="3" col="3"/></div>
    <!--最新资讯-->
    <div class="content-row">
      <div class="content-col col-per-30">
        <infoList title="最新资讯" label="LAST NEWS" count="4" :titleLength="13"  :labelLength="28" :infoBlock="infoBlock08" :infoPage="infoPage08" moreLink="/hyzx" v-on:queryPage="zxzx_Req"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="种植技术" label="POUPLAR INFORMATION" count="9" :titleLength="17" :infoBlock="infoBlock09" :infoPage="infoPage09" moreLink="/jrkjfw/zzjs" v-on:queryPage="zzjs_Req"/>
      </div>

      <div class="content-col col-per-30">
        <imageSlide01 title="行业展会" label="POUPLAR INFORMATION" count="5" :titleLength="14" :infoBlock="infoBlock10" :infoList="infoList11" :showMore="true" moreLink="/hyzx/05" v-on:queryPage="hyzh_Req"/>
        <!--<infoList title="孟连三农" label="POUPLAR INFORMATION" count="4" :titleLength="17" :infoBlock="infoBlock09" :infoPage="infoPage10" v-on:queryPage="mlsn_Req"/>-->
      </div>
    </div>
    <!--数据服务-->
    <div class="content-row"><imgLink-02 title="数据服务" label="DATA SERVICE" :showMore="false" col="2"  count="3"/></div>
    <div class="content-row" style="height: 60px;"></div>
  </div>
</div>
</template>

<script>
import InfoList from '../block/InfoList'
import ImageSlide01 from '../block/ImageSlide01'

import InfoBlock08 from '../block/InfoBlock08'
import InfoBlock09 from '../block/InfoBlock09'
import InfoBlock10 from '../block/InfoBlock10'

import InfoList01 from '../block/InfoList01'
import InfoList02 from '../block/InfoList02'
import InfoTabList01 from '../block/InfoTabList01'
import ChartTabList01 from '../block/ChartTabList01'
import ChartTabList02 from '../block/ChartTabList02'
import ImgLink01 from '../block/ImgLink01'
import ImgLink02 from '../block/ImgLink02'
import ImgLink03 from '../block/ImgLink03'
export default {
  name: 'Home01',
  components: {
    'infoList':InfoList,
    'imageSlide01':ImageSlide01,
    'infoList-01': InfoList01,
    'infoList-02': InfoList02,
    'infoTabList-01': InfoTabList01,
    'chartTabList01-01': ChartTabList01,
    'chartTabList02-01': ChartTabList02,
    'imgLink-01':ImgLink01,
    'imgLink-02':ImgLink02,
    'imgLink-03':ImgLink03,
  },
  data() {
    return {
      msg: '',
      infoBlock08:InfoBlock08, //最新资讯
      infoPage08:{list:[],page:{page:1,total:0}}, //最新资讯

      infoBlock09:InfoBlock09, //种植技术
      infoPage09:{list:[],page:{page:1,total:0}}, //种植技术

      infoPage10:{list:[],page:{page:1,total:0}}, //孟连三农

      infoBlock10:InfoBlock10, //行业展会
      infoPage11:{list:[],page:{page:1,total:0}}, //行业展会
      infoList11:[],//行业展会
      swiperOption: {
        slidesPerView: 1,
        // 设置分页器
        pagination: {
          el: '.swiper-pagination',
          // 设置点击可切换
          clickable: true
        },
        // 设置自动轮播
        autoplay: {
          delay: 5000 // 5秒切换一次
        },
        // 设置轮播可循环
        loop: false
      }
    }
  },
  methods:{
    //最新资讯
    zxzx_Req(params){
      params.type='news';
      let that=this;
      let result={page:params};
      //console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.articleList(params).then(res =>{
          that.msg=res.msg;
          //that.tabList=res.data.list;
          //that.tabList=[];
          result.list= res.data.list;
          result.page.total=res.data.total;

          that.infoPage08=result;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
        });

    },
    //种植技术
    zzjs_Req(params){
      params.type='plant_technique';
      let that=this;
      let result={page:params};
      //console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.articleList(params).then(res =>{
          that.msg=res.msg;
          //that.tabList=res.data.list;
          //that.tabList=[];
          result.list= res.data.list;
          result.page.total=res.data.total;

          that.infoPage09=result;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
        });

    },
    //孟连技术
    mlsn_Req(params){
      params.type='policy_library';
      let that=this;
      let result={page:params};
      //console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.articleList(params).then(res =>{
          that.msg=res.msg;
          //that.tabList=res.data.list;
          //that.tabList=[];
          result.list= res.data.list;
          result.page.total=res.data.total;

          that.infoPage10=result;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
        });

    },
    //行业展会
    hyzh_Req(params){
      params.type='policy_library';
      let that=this;
      let result={page:params};
      //console.log('行业展会开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.expoList(params).then(res =>{
          that.msg=res.msg;
          //that.tabList=res.data.list;
          //that.tabList=[];
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoList11=res.data.list;
          that.infoPage11=result;
          //console.log('结束请求Vue-行业展会：'+JSON.stringify(infoList11))
        });

    },

  },//methods end-----
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.col-per-30 {
  flex-grow:1;
}

.content-row{
  width:1024px;
  margin:0 auto;
}
.content-row-c1{
  width:100%;
  background:#eee;
}

.content-row-c1 .content-block{
  width:1024px;
  margin:0 auto;
  background:#eee;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home01.vue